import { Action, ActionCreator } from 'redux';
import { ThunkDispatch, ThunkAction } from "redux-thunk/index";
import { SipState, CallInfo } from './types';
import { Sip } from "../../sip/sip";
import { CallerAccountInfo } from '../../sip/sipTypes';
import { localStorageGetItem } from '../../utils/storage';
import BUILD_PARAMS from '../../utils/build';


export enum SipActionTypes {
    INITIALIZE_SIP = 'INITIALIZE_SIP',
    INITIALIZE_SIP_SUCCESS = 'INITIALIZE_SIP_SUCCESS',
    INITIALIZE_SIP_FAIL = 'INITIALIZE_SIP_FAIL',
    SIP_STATE_CHANGED = 'SIP_STATE_CHANGED',
    SIP_ADD_CALL_HISTORY = 'SIP_ADD_CALL_HISTORY',
    SIP_INCOMING_CALL = 'SIP_INCOMING_CALL',
    SIP_DISCONNFCTED_ERROR = 'SIP_DISCONNFCTED_ERROR'
}


export interface IInitializeSipAction extends Action<SipActionTypes.INITIALIZE_SIP> {
}
export interface IInitializeSipSuccessAction extends Action<SipActionTypes.INITIALIZE_SIP_SUCCESS> {
    login: string,
    username: string,
    calls: CallInfo[],
}
export interface IInitializeSipFailAction extends Action<SipActionTypes.INITIALIZE_SIP_FAIL> {
    error:string
}
export interface ISipStateChangedAction extends Action<SipActionTypes.SIP_STATE_CHANGED> {
    phoneNumber: string;
    hasActiveCall: boolean;
    isEstablished: boolean;
    isIncoming: boolean;
    isMuted: boolean;
    callerAccountInfo?: CallerAccountInfo;
}
export interface ISipIncomingCallAction extends Action<SipActionTypes.SIP_INCOMING_CALL> {
    phoneNumber: string;
    callerAccountInfo?: CallerAccountInfo;
}
export interface ISipAddCallHistoryAction extends Action<SipActionTypes.SIP_ADD_CALL_HISTORY> {
    call: CallInfo
}

export interface ISipDisconnectedErrorAction extends Action<SipActionTypes.SIP_DISCONNFCTED_ERROR> {
    sipDisconnectedError: boolean
}


export type SipActions =
    | IInitializeSipAction
    | IInitializeSipSuccessAction
    | ISipStateChangedAction
    | ISipAddCallHistoryAction
    | ISipIncomingCallAction
    | IInitializeSipFailAction
    | ISipDisconnectedErrorAction;


export function sipDisconnectedAction(sipDisconnectedError: boolean) {
    const action: ISipDisconnectedErrorAction = {
        type: SipActionTypes.SIP_DISCONNFCTED_ERROR,
        sipDisconnectedError: sipDisconnectedError
    }
    return action;
}

export function sipAddCallHistoryAction(call: CallInfo) {
    const action: ISipAddCallHistoryAction = {
        type: SipActionTypes.SIP_ADD_CALL_HISTORY,
        call: call
    }
    return action;
}

export function sipStateChangedAction(phoneNumber: string, hasActiveCall: boolean, isEstablished: boolean, 
    isIncoming: boolean, isMuted: boolean, callerAccountInfo?: CallerAccountInfo) {
    const action: ISipStateChangedAction = {
            type: SipActionTypes.SIP_STATE_CHANGED,
            phoneNumber: phoneNumber,
            hasActiveCall: hasActiveCall,
            isEstablished: isEstablished,
            isIncoming: isIncoming,
            isMuted: isMuted,
            callerAccountInfo,
        }
    return action;
}

export function sipIncomingCallAction(phoneNumber: string, callerAccountInfo?: CallerAccountInfo) {
    return (dispatch: ThunkDispatch<SipState, void, Action<any>>) => {
        const action: ISipIncomingCallAction = {
            type: SipActionTypes.SIP_INCOMING_CALL,
            phoneNumber,
            callerAccountInfo
        }
        dispatch(action);
        const historyAction: ISipAddCallHistoryAction = {
            type: SipActionTypes.SIP_ADD_CALL_HISTORY,
            call: new CallInfo(new Date(), phoneNumber, true, false),
        }
        dispatch(historyAction);
    }
}

export const initializeSipActionCreator: ActionCreator<ThunkAction<Promise<any>, SipState, string, IInitializeSipSuccessAction>> =
    (login: string, pass: string, username:string) => {
        return async (dispatch: ThunkDispatch<SipState, void, Action<any>>) => {
            const initAction: IInitializeSipAction = {
                type: SipActionTypes.INITIALIZE_SIP
            };
            (dispatch as ThunkDispatch<SipState, void, Action<any>>)(initAction);

            try {
                //Sip.Initialize("sip:100@sip.sedi.ru", "2302377b09a8605b5443306acae4841e", "wss://sip.sedi.ru:8089/ws");
                Sip.Initialize(login, pass, BUILD_PARAMS.SIP_URI!);
                let callHistoryJson = localStorageGetItem("calls_" + username);
                let callhistory: CallInfo[] = callHistoryJson === null ? [] : JSON.parse(callHistoryJson, Helper.CallInfoRevive);
                const successAction: IInitializeSipSuccessAction = {
                    type: SipActionTypes.INITIALIZE_SIP_SUCCESS,
                    login: login,
                    calls: callhistory,
                    username: username,
                };
                (dispatch as ThunkDispatch<SipState, void, Action<any>>)(successAction);
            } catch (e) {
                const failAction: IInitializeSipFailAction = {
                    type: SipActionTypes.INITIALIZE_SIP_FAIL,
                    error: e.message
                };
                (dispatch as ThunkDispatch<SipState, void, Action<any>>)(failAction);
            }
        }
    }

class Helper {
    public static CallInfoRevive(key: any, value: any): any {
        if (key === 'time') {
            return new Date(value);
        }

        return value;
    }
}